module.exports = __webpack_public_path__ + "img/koala.3e8a33e.png";